import type { Coords } from '../types';

// ============================================================
// GEOCODING — Address to lat/long coordinates
// Uses Nominatim (OpenStreetMap) — free, no API key
// Falls back to offline hash-based coords if API unavailable
// ============================================================

const isOffline = typeof window !== 'undefined' && window.location.protocol === 'file:';

export async function geocodeAddress(address: string): Promise<Coords> {
  if (!isOffline) {
    try {
      const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}&limit=1&countrycodes=us`;
      const resp = await fetch(url, { headers: { Accept: 'application/json' } });
      if (resp.ok) {
        const data = await resp.json();
        if (data && data.length > 0) {
          return {
            lat: parseFloat(data[0].lat),
            lon: parseFloat(data[0].lon),
            display: data[0].display_name,
            offline: false,
          };
        }
      }
    } catch {
      // fall through to offline
    }
  }

  // Offline fallback: hash address to plausible US coordinates
  let hash = 0;
  for (let i = 0; i < address.length; i++) {
    hash = ((hash << 5) - hash) + address.charCodeAt(i);
    hash |= 0;
  }
  const lat = 25 + (Math.abs(hash) % 2300) / 100;
  const lon = -125 + (Math.abs(hash >> 8) % 5800) / 100;
  return {
    lat: parseFloat(lat.toFixed(4)),
    lon: parseFloat(lon.toFixed(4)),
    display: address,
    offline: true,
  };
}
